import { isEmpty } from 'lodash';
import { v4 as uuid } from 'uuid';
import { epoch, utc } from '../../util/datetime';
import { addTrail, toUUID } from '../../util/transform';
import { OpportunityContextualType } from '../opportunity/OpportunityContextual.enum';
import type { IOrganizationAccess } from './OrganizationAccess.interface';
import OrganizationAccessWebForm from './OrganizationAccessWebForm';

export default class OrganizationAccess implements IOrganizationAccess {
  id: string;
  idWorkflow: string;
  idStage: string;
  idTeamMember: string;
  diversification: any;
  name: string;
  url: string;
  webForm: OrganizationAccessWebForm;
  isLoanq: boolean;
  isWebForm: boolean;
  isOutbound: boolean;
  isActive: boolean;
  timeStamp: number;

  static build = (data: IOrganizationAccess) => new OrganizationAccess(data);
  static blank = (data: IOrganizationAccess) =>
    new OrganizationAccess({ id: uuid(), isActive: true, ...data });

  getExternalFormCode(org, logo, prv, eml, typ) {
    const cdn = this.isLoanq
      ? 'https://public.loanq.com.au/#/'
      : 'https://wef.salestrekker.com';
    return `<div><iframe src="${cdn}?logoUrl=${encodeURI(logo)}&p=${encodeURI(
      prv
    )}&n=${encodeURI(this.name)}&o=${encodeURI(org)}&e=${encodeURI(
      eml
    )}&t=${typ}${this.webForm.getUrl()}&u=${encodeURI(addTrail(this.url, '/'))}&k=${
      this.id
    }" style="border:0;height:650px;width:100%;"></iframe></div>`;
  }

  /**
   * Constructor
   * @param {IOrganizationAccess} data
   */
  constructor(data?: IOrganizationAccess) {
    this.id = toUUID(data?.id);
    this.idWorkflow = toUUID(data?.idWorkflow);
    this.idStage = toUUID(data?.idStage);
    this.idTeamMember = toUUID(data?.idTeamMember);
    this.diversification = !isEmpty(data.diversification)
      ? OpportunityContextualType.of(data?.diversification?.name)
      : undefined;
    this.name = data?.name || undefined;
    this.url = data?.url || undefined;
    this.webForm = new OrganizationAccessWebForm(data?.webForm);
    this.isLoanq = data?.isLoanq === true;
    this.isWebForm = data?.isWebForm === true;
    this.isOutbound = data?.isOutbound === true;
    this.isActive = data?.isActive === true;
    this.timeStamp = epoch(utc(data?.timeStamp));
  }
}
